import { useEffect, useState } from "react";
import { AccordionDetails, AccordionSummary, Typography } from "@mui/material"
import MuiAccordion from "@mui/material/Accordion";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const BaseAccordion = ({ item, sx, sxSummary, isExpand = true, isExpandIcon = true, children, ...props }) => {
  const [expanded, setExpanded] = useState(true)

  useEffect(() => setExpanded(isExpand), [isExpand])

  return (
    <div onClick={props.onClick}>
      <Accordion
        sx={{
          zIndex: 0,
          width: '100%',
          // marginBottom: "15px",
          backgroundColor: "primary.white",
          borderRadius: "8px",
          padding: '16px',
          boxShadow: '0px 2px 10px 0px #5B87EF33',
          ...sx
        }}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        {...props}
      >
        <AccordionSummary
          expandIcon={isExpandIcon ? <ExpandMoreIcon sx={{ color: "primary.black" }} /> : <></>}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            padding: 0,
            minHeight: 0,

            ...sxSummary,
            '.MuiAccordionSummary-content': {
              margin: 0
            }
          }}
        >
          <Typography variant="h4" color="primary.black">{item?.title}</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            px: 0,
            pb: 0
          }}
        >
          {item?.description && (
            <Typography
              variant="body"
              color="primary.darkGray"
              whiteSpace='pre-wrap'
            >
              {item?.description}
            </Typography>
          )}
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
    )
}

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: 'none',
  
  '&:not(:last-child)': {
    borderBottom: 0,
    // marginBottom: '14px',
  },
  '&:before': {
    display: 'none',
  },
}));

export default BaseAccordion